module.exports = __webpack_public_path__ + "static/media/1022236.a9aa1b99.jpg";